import * as catalogos from './catalogos/en';
export const locale = {
  lang: 'nl',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'Algemene data',

      'HEADER': 'Companies',
      'BUSCAR': 'Zoek bedrijf',
      'BUSCAR_PLACEH': 'Voer de naam in van het bedrijf dat u wilt zoeken',
      'EMPRESA': 'Bedrijf',
      'MESSAGE3':'<span> Als u zeker weet dat u het product logisch wilt verwijderen, voert u de tekst in het rood in het tekstvak in:',
      'MESSAGE4':'</span>',
      'CANCELAR': 'Annuleren',
      'COMFIR': 'Bevestig',
      'PROC_DELE_PROD':'Product verwijderen',
      'SUCC_DELE_PROD':'Product werd met succes verwijderd',
      'DELE_PRODU':'Product verwijderen',
      'TEX_VERS_RESULT_OPC1':'Standaardversie',
      'TEX_VERS_RESULT_OPC2':'Aangepaste versie',
      'TEX_VERS_RESULT_LAB':'Aangepaste versie',
      'TEX_PLAC_RESULT_LAB':'Aangepaste versie invoeren',
      'TEX_MOD_RESULT_VERS':'U moet het type resultaatversie invoeren',
      'ACCION': 'Actions',
      'CREAT_DATE_EMP':'Datum van creatie',
      'TYP_REGISTR_EMP':'Type registratie',
      'AUTOR_EMP':'Auteur',
      'SELECT_PLANTILLA': 'Selecteer een sjabloon',
      'SELECT_EMAIL_PLANTILLA': 'Selecteer een e-mailsjabloon',
      'DETALLE': 'Producten',
      'MANAGER_TI': 'Manager van IT',
      'STATUS':'Enquêtestatus',
      'EMA_HISTO':'Mailgeschiedenis',
      'LABEL1': 'Bedrijfsgegevens',
      'DESCDETAIL': 'Hoekige reactieve vormen lopen tussen een niet-UI-gegevensmodel (meestal opgehaald van een server) en een UI-georiënteerd formuliermodel dat de toestanden en waarden van de HTML-besturingselementen op het scherm behoudt. Reactieve vormen bieden het gemak van het gebruik van reactieve patronen, testen en validatie',
      'DETAIL': 'Detail',
      'SECTOR': 'Sector',
      'SUBSECTOR': 'Subsector',
      'RANKING': 'Ranglijst',
      'TIPO': 'Type',
      '0': 'Wit pictogramontwerp',
      '1': 'Geel pictogramontwerp',
      '4': 'Pictogram Ontwerp Cirkels',
      'Reactivos': 'Verklaringen',
      'NPS': 'Overkoepelende verklaring',
      'Demograficos': 'Demografisch',
      'Forall': 'Voor iedereen',
      'Adicionales': 'Aanvullende verklaringen',
      'Control': 'Controle',
      'Abiertas': 'Open vragen',
      'URL':'Koppeling',

      'SELECCIONE_FECHA': 'Lijstjaar',
      'SELECT_CSSID': 'Jaar van toepassing',
      'SELECT_CSSIDR': 'Jaar van toepassing',
      'TIPORANKING': 'Positietype ',
      'TIP_PRODU': 'Producttype',
      'TIP_PLAN_PRO': 'Sjabloonnaam',
      'TIP_DIS_PRO': 'Ontwerp',
      'SELECT_CSSID2': 'Selecteer een enquête-ontwerp',
      'SELECT_RESULTS': 'Selecteer een product',
      'SURVEYTK_TITU': 'Enquêtetoken',
      'SURVEYTK_DESC': 'Voer de enquêtetoken voor dit product in',
      'TABLEAUVER_TITU': 'Resultaten versie ',
      'TABLEAUVER_DESC': 'Voer de resultatensysteemversie voor dit product in',
      'IDOPORTUNITY': 'Opportunity-ID (Sales Force)',
      'NAMEOPORTUNITY': 'Naam van de gelegenheid (Sales Force)',
      'IDTYPERESULT': 'resultaatsoorten',
      'NAM_USE_SWIFT': 'Gebruikersnaam',
      'TO_USE_SWIFT': 'Totaal aantal medewerkers',
      'EMA_USE_SWIFT': 'E-mail gebruiker',
      'PASS_USE_SWIFT': 'Wachtwoord gebruiker',
      'CAT_RES':{
        '1': 'Volledige resultaten',
        '2':'Basisresultaten',
      },
      'PROYECTMANAGER': 'Projectleider',
      'PROYECTMANAGER_MAIL': 'E-mailadres van projectmanager',
      'CONFIGURE': 'Klik hier om te configureren ',
      'INFOR': 'Info',
      'ADDPRODUCTS': 'Voeg producten toe',
      'ADD': 'Toevoegen',
      'NAME_SURVEY':'Onderzoeksnaam:',
      'UPDATE_NAME_SURVEY':'Het bijwerken van de naam ',
      'LABELCONTRATADOS': 'Producten in gebruik',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Lijst met geregistreerde bedrijven laden',
      'EDITAR': 'Bewerk bedrijfsinformatie',
      'LOGIN': 'Log in',
      'PAGINATOR_1': 'van',
      'PAGINATOR_2': 'bedrijven',
      'TIMELINE': 'T.R. tijdlijn',
      'PAQUETES': 'Packages',
      'ELIMINAR': 'Bedrijf verwijderen',
      'CORREOMODIF': 'Dit product heeft wijzigingen in de inhoud van de e-mail',
      'CORREOMODIFMODAL': 'Er zijn nieuwe e-mailwijzigingen die in afwachting zijn van validatie in een of meer producten. Controleer ze',
      'CORREOMODAL_2': 'Nieuwe e-mailwijzigingen zijn momenteel in afwachting van validatie',
      'MODIFBTN': 'Product instellingen',
      'INF_BTN': 'Productinformatie',
      'INF_PROD_SEL': 'Productgegevens',
      'VALIDMAIL_1': 'Valideer wijzigingen',
      'VALIDMAIL_2': 'Gevalideerde e-mail',
      'VALIDMAIL_3': 'Wilt u de wijzigingen in het bericht valideren?',
      'VALIDMAIL_4': 'De wijzigingen in de e-mail zijn correct gevalideerd',
      'VALIDMAIL_5': 'Veranderingen afwijzen',
      'VALIDMAIL_6': 'Wilt u de wijzigingen in het bericht afwijzen?',
      'VALIDMAIL_7': 'De wijzigingen in de hoofdtekst van de e-mail zijn afgewezen. In plaats daarvan wordt de standaard e-mailsjabloon gebruikt',
      'VALIDMAIL_8': 'Geweigerde e-mail',
      'VALIDMAIL_9': 'Maak bewerken voor het bedrijf mogelijk',
      'VALIDMAIL_10': 'Wilt u het bewerken van e-mail voor het bedrijf weer inschakelen?',
      'VALIDMAIL_11': 'De editie is ingeschakeld voor het bedrijf',
      'VALIDMAIL_12': 'E-mail bewerken',
      'VALIDMAIL_13': 'Nu kunt u de e-mail bewerken die door het bedrijf is verzonden',
      'SINCORREOS': 'Er zijn geen e-mails om te valideren',
      'FILEMANODS': 'Bestandsbeheer',
      'TEX-MENS-1':'Het bedrijf',
      'TEX-MENS-2':'geen gebruikers',
      'FILEMAN_PRIV': 'Privérit ',
      'FILEMAN_PUB': 'Openbare schijf',
      'USUARIO':'User',
      'AL':'to',
      'SEN_EMAIL_REQ': 'Wilt u de technische vereisten e-mail sturen',
      'SEN_EMAIL_REQ_PROD': 'Zorg ervoor dat u de e-mail met technische vereisten verstuurt',
      'ETIQUE_SEN_EMAIL_REQ_PROD': 'Mailing technische vereisten',
      'EMAIL_REQ_PLACE': 'Selecteer een taal',
      'EMAIL_REQ_INTRO': 'Selecteer een taal om verder te gaan',
      'WARN_SEN_EMAIL_REQ_PROD': 'Om verder te gaan moet u een taal selecteren',
      'TOOLTI_SEN_EMA': 'Verzend mail',
      'ESTA_EMA_TRUE': '*Verzend mail',
      'ESTA_EMA_FALSE': '*Geen verzonden mail',
      'SEN_EMAIL_MODAL': 'Email verzenden ......',
      'RTINFO': 'Technische vereisten informatie',
      'TOOTI_RES_EMPR':'Resultaten empresing',
      'WARNI_SELCT_CHECK':'Om verder te zoeken is het verplicht ten minste één vakje aan te vinken',
      'REQ':{
        'BTNSI':'Ja',
        'BTNNO':'Nee',
        'MENSAJE1':'Wilt u de technische vereisten activeren?',
        'MENSAJE2':'Wilt u de technische vereisten deactiveren ',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'Activeer de e-maileditor voor dit product',
        'OPCION_2': 'Automatische validatie van wijzigingen',
        'OPCION_3': 'Activeer vereiste details over het onderzoeksproces',
        'OPCION_4': 'Activeer enquêtevalidatie voor focusgebied',
        'OPCION_5': 'Sta toe om de applicatietijd te wijzigen',
        'OPCION_6': 'Extensies toestaan',
        'OPCION_7':'Kans met succes op details van vereisten in het onderzoeksproces',
        'OPCION_8': 'Aantal toewijsbare herinneringen',
        'OPCION_9': 'Activeer de sluitingsdatumeditie',
        'OPCION_10': 'Activeer heropening van stappen',
        'OPCION_11_ENTREGABLES': 'Toon resultaten van te leveren producten in het telportaal',
        'OPCION_11_RANKING': 'Toon certificeringsresultaten en rangschikking in het telportaal',
        'OPCION_12':'Schakel onderzoeksbescherming in met gebruikerspincodes',
        'OPCION_13':'Schakel de willekeurige validatievraag in',
        'OPCION_14': 'Toon Instructions Box in Survey-app',
        'OPCION_15': 'Toon ondersteuningsbox in enquête-applicatie',
        'OPCION_16': 'Toon gebruikersnaam in de enquête-app',
        'MODAL_OP11_ON': 'De functie voor heropening van stappen is geactiveerd voor dit product',
        'MODAL_OP12_OF': 'De functie voor heropening is voor dit product gedeactiveerd',
        'MODAL_OP1_ON': 'E-maileditor voor dit product is geactiveerd ',
        'MODAL_OP1_OFF': 'E-maileditor voor dit product is uitgeschakeld',
        'MODAL_OP2_ON': 'Automatische validatie van wijzigingen is geactiveerd voor dit product',
        'MODAL_OP2_OFF': 'Automatische validatie van wijzigingen voor dit product is uitgeschakeld',
        'MODAL_OP6_ON': 'Rollovers toestaan voor dit product is uitgeschakeld',
        'MODAL_OP6_OFF': 'Das Zulassen von Rollovers für dieses Produkt wurde ausgeschaltet',
        'MODAL_OP7_ON': 'Het aantal toewijsbare herinneringen voor dit product is gewijzigd',
        'MODAL_OP8_ON': 'Het wijzigen van de sluitingsdatum van de enquête is geactiveerd voor dit product',
        'MODAL_OP8_OFF': 'Het bewerken van de sluitingsdatum van de enquête voor dit product is uitgeschakeld',
        'MODAL_OP11_ENTREGABLES_ON': 'De steekproef van leverbare resultaten is geactiveerd',
        'MODAL_OP11_ENTREGABLES_OFF': 'De steekproef van leverbare resultaten is gedeactiveerd',
        'MODAL_OP11_RANKING_ON': 'Monster voor certificering en rangschikking van resultaten geactiveerd',
        'MODAL_OP11_RANKING_OFF': 'Voorbeeld van certificerings- en rangschikkingsresultaten is gedeactiveerd',
        'MODAL_PIN_ON':'Pin is ingeschakeld',
        'MODAL_PIN_OFF':'Pin is uitgeschakeld',
        'MODAL_PRECONTROL_ON':'Willekeurige validatievraag is geactiveerd',
        'MODAL_PRECONTROL_OFF':'Willekeurige validatievraag is uitgeschakeld',
        'MODAL_OP14_ON': 'Weergave van het instructievak in de enquêtetoepassing is actief',
        'MODAL_OP14_OFF': 'Weergave van het instructievak in de enquêtetoepassing is gedeactiveerd',
        'MODAL_OP15_ON': 'Toon ondersteuningstabel in de toepassing van de enquête actief',
        'MODAL_OP15_OFF': 'Toon ondersteuningstabel in de toepassing van de enquête is gedeactiveerd',
        'MODAL_OP16_ON': 'Het tonen van de gebruikersnaam in de enquêtetoepassing is actief',
        'MODAL_OP16_OFF': 'Weergave van de gebruikersnaam in de enquêtetoepassing is gedeactiveerd',
        'TITUOPTS': 'Opties',
        'TITUCORRS': 'E-mails die nog moeten worden gevalideerd',
        'SELLANG': 'Selecteer een taal uit de lijst om de e-mail te bekijken',
        'SELLANG_L': 'Selecteer een taal',
        'ASUNTO': 'E-mail onderwerp',
        'ASUNTOPILOTO': 'Onderwerp van pilootmail',
        'WAIT':'Wisselgeld opslaan',
        'ULTD': 'Unlimited',
        'CLOUD_LEGACY': 'Activeer bijgewerkte versie van bestandsbeheer',
        'CUSTOM_TEXT_CERT': 'Activeer multi-site certificaattekst',
        'CUSTOM_TEXT_CERT_EDIT': 'Bewerk de certificaattekst',
        'TEXT_SECC_CONF_VOIC': 'Toon spraakconfiguratiesectie',
        'SAVED_CHANGES': 'De wijziging is succesvol opgeslagen',
        'CUSTOM_TEXT': {
          'TITULO': 'Lijst van de landen waar het multi-site certificaat dekking heeft',
          'SUBTITULO': 'Schrijf de nieuwe tekst',
          'SUBTITULO2': 'Waarschuwing, als u de tekst wijzigt en op de knop OK klikt, wordt de huidige tekst overschreven',
          'HINT': 'Certificaattekst',
          'OK': 'Aanvaarden',
          'CANCEL': 'Annuleren',
          'SAVED_CHANGES': 'De tekst is correct opgeslagen',
          'CURRENT_T1': 'Huidige multi-site tekst',
          'CURRENT_T2': 'De huidige tekst voor meerdere sites is erg lang, om deze te bekijken klikt u op de knop Bewerken',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Koppel cultuuraudit aan een certificaat',
        'INPUT':'Certificaat dat moet worden gekoppeld',
        'INPUT_2':'Product te associëren',
        'CERTIFICAR':'Certificeren',
        'MEDIR':'Maatregel',
      },
      'LOG_SISTEMA':{
        'TITULO':'Systeem log',
        'BUSCADOR':'Zoekresultaten',
        'PLACEHOLDER':'Zoeken',
        'ACTUALIZAR':'Bijwerken log',
        'PAGINA':'Bladzijde',
        'CARGA':'Data laden...',
        'TABLA':{
          'IMAGEN':'Beeld',
          'IP':'Cliënt IP',
          'USER':'Gebruiker',
          'COMPANY':'Bedrijf',
          'PLATFORM':'Platform',
          'STATUS':'Toestand',
          'RESULT':'Resultaat',
          'DATE':'Datum',
        },
      },
      'LOG_SENDGRIND':{
        'TITULO':'SendGrid\'s Log',
        'OPCION':'Kies een optie:',
        'TOOLTIP':'Zoekstatus',
        'TABLA':{
          'USUARIO':'Gebruiker',
          'EMAIL':'E-mail',
          'ASUNTO':'Onderwerpen',
          'ESTATUS':'Toestand'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Mailinginformatie',
          'TO':'Naar',
          'FROM':'Van',
          'SUBJECT':'Onderwerpen',
          'HISTORIAL':'E-mailgeschiedenis',
          'ESTATUS':'Toestand',
          'ABIERTO':'Tijden open:',
          'ULTIMO_EVENTO':'Laatste evenement:',
          'SIN_CORREOS':'Uw e-mailgeschiedenis is niet beschikbaar!',
          'BOTON':'Dichtbij',
          'NOTE':'OPMERKING: De datum, tijd / tijd die in de lijst wordt weergegeven, is ingesteld op de lokale tijd in  ',
        },
      },

      'CONFIR_CAMBIOS_SECCION': 'De enquête is momenteel al aangemaakt,,\n\n weet u zeker dat u de wijzigingen wilt doorvoeren?\n\n Als u bevestigt, genereert u de enquête opnieuw',
      'MODAL_CAMBIOS_SECCION': 'Secties bijwerken',
      'TIT_MOD_AGRE_ENCU': 'Nieuw enquêteproces',
      'TEX_NAM_SUR': 'Naam enquête:',
      'TEX_PLA_SUR': 'Sjabloonselectie',
      'BTN_AGRE_SUR': 'Toevoegen',
      'PLA_TEX_NAM_SUR': 'Enquêtenaam:',
      'PLA_TEX_PLA_SUR': 'Sjabloonselectie',
      'WARNI_NOT_SURV_NOM35':'De enquête wordt momenteel niet gegenereerd',
      'MODAL_CREAT_INFRA':'Infrastructuur wordt aangemaakt, gelieve te wachten',
      'MODAL_ERROR_INFRA':'Er is een fout opgetreden bij het creëren van de infrastructuur',
    },

    'GESTORSTATUS': {
      'BOTACCESO': 'Products information',
      'TITULO': 'Verworven producten',
      'PRODUCTOS':{
        'CERTIFICAR': 'Certificeren',
        'MEDIR': 'Meting',
        'PULSE': 'Pulscontrole',
        'FOCUS': 'Focusgebied',
        'NUMPROD': 'Aantal producten: ',
        'BOTACCESO': 'Zie producten',
        'NOPRODUCTOS': 'U heeft geen gekochte producten'
      },
      'PRODSINFO': {
        'ADQUIRIDOS': 'Verworven producten',
        'SELECCIONE': 'Select a product from the list to show its information'
      },
      'STATUS': {
        'LISTA': 'Stappenlijst',
        'CURRENT': 'Stapstatus',
        'INFO': 'Deze lijst toont de huidige status voor elke stap van het certificeringsproces. \n\n U kunt de status wijzigen van "Voltooid" naar "Niet voltooid" door op een stapschuifregelaar te klikken. \n\n Opmerking: sommige stapstatus kan alleen worden gewijzigd onder bepaalde omstandigheden',
        'NO': 'Niet compleet',
        'SI': 'Stap voltooid',
        'TOOLTIP': {
          'HELP': 'Klik hier voor meer informatie',
          'SLIDER': 'Click here to change the status for this step'
        }
      }
    },

    'ALERTS': {
      'OK': 'OK',
      'ODSINSERTOK': 'Het bedrijf is correct geregistreerd',
      'ODSFAILINSERT': 'Het registratieproces is mislukt, probeer het opnieuw',
      'COLPLETEFORM1': 'lease volledige stap 1',
      'COLPLETEFORM2': 'lease volledige stap 2',
      'COLPLETEFORM3': 'lease volledige stap 3',
      'COLPLETEFORM4': 'lease volledige stap 4',
      'COLPLETEFORM5': 'lease volledige stap 5',
      'ODSEXIST': 'Het registratieproces is mislukt, probeer het opnieuw',
      'MAIL':'¿U wilt de post opnieuw verzenden naar de verschillende verantwoordelijke personen?',
      'RSPSI':'Ja',
      'RSPNO':'Nee',
      'LABEL01':'U heeft al een NOM 035-product',
      'FIELD':'Vereiste link',
      'PASSWORD': {
        'LONGITUD': 'Het wachtwoord moet minimaal acht tekens lang zijn',
        'MINUSCULAS': 'Het wachtwoord moet minstens één kleine letter bevatten',
        'MAYUSCULAS': 'Het wachtwoord moet minstens één hoofdletter bevatten',
        'NUMEROS': 'Het wachtwoord moet minimaal één numeriek teken bevatten',
        'ESPCHARS': 'Het wachtwoord moet minstens één speciaal teken bevatten, niet alfanumeriek',
        'VALIDACION': 'Er is een probleem opgetreden bij het valideren van het wachtwoord. Typ het opnieuw en probeer de gebruiker opnieuw te maken'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'Vereiste link',
      'DESCRIPTION': 'Enter the data of the IT manager to send the necessary information and settings that must be executed before the application of the survey',
      'DATOS': 'Gegevens',
      'NOMBRE': 'Naam',
      'APELLIDOS': 'Achternaam',
      'EMAIL': 'E-mail',
      'TELEFONO': 'Telefoon',
      'EXTENSION': 'Uitbreiding',
      'CELULAR': 'Mobiele telefoon',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'PROFILES CREATOR',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Company profile',
          'BOTON': 'Create'
        },
        'BOT2':{
          'TITULO': 'User profile',
          'BOTON': 'Admin'
        },
        'BACK': 'Back',
        'NEXT': 'Next',
        'RESET': 'Reset',
        'EDIT': 'Save'
      },
      'EMPRESA':{
        'WAIT': 'Wacht...',
        'TITUHEAD': 'Bedrijfsprofiel',
        'CLOUD': 'Privémap',
        'INFO': 'Maak een profiel aan voor een bedrijf',
        'INFOMOD': 'U kunt de profielgegevens van dit bedrijf wijzigen <b>(wijzigingen worden automatisch opgeslagen)</b>',
        'PDF':{
          'BOTONDESCARGA':'Download informatie in pdf',
          'FECHA':'Datum: ',
          'HORA':'Tijd: ',
          'MODAL':'Bestand genereren om te downloaden...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Update Cultuur Audit',
          'ACTUALIZARCA_BRI':'Update Cultuur Brief',
          'ACTUALIZARCA_ACTIAN':'Update actieplan',
          'CERRAR':'Dichtbij',
          'SUCCESS':'Culture Audit succesvol bijgewerkt',
          'SUCCESS_ACTION':'Plan actie succesvol bijgewerkt',
          'ERROR':'Fout, uw Cultuur Audit heeft geen gecertificeerd product',
          'ERROR_ACTION':'Fout, uw planactie heeft geen gecertificeerd product',
        },

        'ACTUALIZAR_BD':{
          'TITULO':'Instructies',
          'INSTRUCCIONES':{
            'INSTRUCCION_1':'Download de database van medewerkers die ik op het platform bewaar.',
            'INSTRUCCION_2':'Download de sjabloon die door het platform wordt geleverd en kopieer de gegevens van uw samenwerkingsdatabase naar deze sjabloon.',
            'INSTRUCCION_3':'Breng de nodige wijzigingen aan in uw medewerkersdatabase.',
            'INSTRUCCION_4':'Zodra de wijzigingen aan uw bijdragerdatabase zijn voltooid, verwijdert u uw vorige bijdragerdatabase.',
            'INSTRUCCION_5':'Klik op de knop om uw bijgewerkte samenwerkingsdatabase te uploaden en klik op accepteren.'
          },
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Bedrijfsinfo',
            'TITULOPDF': 'Bedrijfsinfo',
            'NOMEMP': 'Company name',
            'NOM': 'Naam',
            'SECTORREQUIRED': 'Sector is vereist',
            'SUBSECTORREQUIRED': 'Subsector is vereist',
            'ANIOFU': 'jaar van oprichting',
            'SALESFORCE': 'Salesforce-ID',
            'CODE': 'Company ID',
            'SALES_REQUIRED': 'Salesforce-ID is vereist',
            'CODE_REQUIRED': 'Het bedrijfs-ID is vereist',
            'INSTITUTO': 'Instituut',
            'INSTITUTO_REQUIRED': 'Instituut is vereist',
            'COMPANY': 'Bedrijf',
            'COMPANY_REQUIRED': 'De naam van het bedrijf is vereist',
            'CAMPO_INVALID': 'Het veld staat de volgende tekens niet toe /*?"<>:\'',
            'COMPANY_ACOR': 'Korte bedrijfsnaam',
            'MOD_INGRE_ACORT': 'Om verder te gaan voer de korte bedrijfsnaam in',
            'ACORT_REQUIRED': 'Korte bedrijfsnaam is verplicht',
            'SEDE': 'Gastland',
            'SEDE_REQUIRED': 'Het is noodzakelijk om het gastland te selecteren om door te gaan',
            'PUBLICATION': 'Lijstnaam',
            'PUBLICATION_REQUIRED': 'De naam van de publicatie is vereist',
            'FUNDATION': 'jaar van oprichting',
            'FUNDATION_REQUIRED': 'Het oprichtingsjaar van het bedrijf is vereist',
            'EMP_TC_REQUIRED': 'Het aantal fulltime medewerkers is vereist',
            'EMP_TP_REQUIRED': 'Gelieve het aantal deeltijdmedewerkers in te vullen',
            'TOTCOL_REQUIRED': 'Vul het totale aantal medewerkers in',
            'RANKING': 'Ranglijst',
            'RANKING_REQUIRED': 'Selecteer een ranglijst',
            'TIPO': 'Bereik van medewerkers',
            'TIPO_REQUIRED': 'Selecteer een reeks medewerkers',
            'MULTINACIONAL': 'Multinationaal',
            'MULTINACIONAL_REQUIRED': 'Multinationaal',
            'ANIORANK_REQUIRED': 'Voer het lijstjaar in',
            'REGION': 'Regio',
            'REGION_REQUIRED': 'Voer uw regio in',
            'PAIS': 'Land',
            'ESTADO': 'Staat, stad of provincie',
            'NAM_RANKIN': 'Naam van het klassement',
            'TYP_RANKIN':'Type rangschikking',

            'OPTSI': 'Ja',
            'OPTNO': 'Nee',

            'EMP_TC': 'Fulltime-medewerkers',
            'EMP_TP': 'Parttime-medewerkers',
            'TOTCOL': 'Aantal werknemers',
            'ANIORANK': 'Lijstjaar',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Selecteer een sector',
              'SUBSECTOR': 'Selecteer een subsector',
              'MULTIN': 'Multinationaal',
              'TIPO': 'Type (Rank or sector)',
              'REGION': 'Selecteer een regio'
            },
            'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': 'Cultureel GO-contact',
            'NOM': 'Voornaam',
            'APE': 'Achternaam',
            'EMAIL': 'Email',
            'TEL': 'Telefoonnummer',
            'EXT': 'Uitbreiding',
            'CEL': 'Mobiele telefoon',

            'NOM_REQUIRED': 'Voer een naam in',
            'APE_REQUIRED': 'Voer uw achternaam in',
            'EMAIL_REQUIRED': 'Voer uw e-mailadres in',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Voer een extensie in',
            'CEL_REQUIRED': 'Voer je mobiel in'

          },
          'SEC3': {
            'TITULO': 'HR Director',
            'NOM': 'Full name',
            'EMAIL': 'Email',
            'TEL': 'Telefoonnummer',
            'EXT': 'Uitbreiding',
            'CEL': 'Mobiele telefoon',

            'NOM_REQUIRED': 'Voer een naam in',
            'EMAIL_REQUIRED': 'Voer uw e-mailadres in',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Voer een extensie in',
            'CEL_REQUIRED': 'Voer je mobiel in'

          },
          'SEC4': {
            'TITULO': 'IT contact',
            'NOM': 'Full name',
            'EMAIL': 'Email',
            'TEL': 'Phone number',
            'EXT': 'Extension',
            'CEL': 'Cellphone',
            'REGISTER': 'Register',

            'NOM_REQUIRED': 'Voer een naam in',
            'EMAIL_REQUIRED': 'Voer uw e-mailadres in',
            'TEL_REQUIRED': 'Enter your phone',
            'EXT_REQUIRED': 'Voer een extensie in',
            'CEL_REQUIRED': 'Voer je mobiel in'

          },
          'SEC5': {
            'TITULO': 'Deliverables',
            'ENTRE': 'Deliverable',
            'TIPO': 'Type'
          }
        },
        'MENSAJES':{
          'CARGABD': 'Upload BD',
          'STATUS': 'STATUS',
          'CORRECTO': 'The company profile was creater successfully',
          'ERROR': 'An error occurred while creating the company profile'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Selecteer de gebruiker waarmee u wilt inloggen',
        'MJS_COMPLETE_INFO': 'Gelieve de gegevens in te vullen.',
        'MSJ_INVALIDEMAIL': 'Gelieve een geldig e-mailadres in te vullen.',
        'MSJ_SELECTCOMPANY': 'Selecteer een bedrijf',
        'REGISTER_SUCCESS': 'Gebruiker succesvol geregistreerd',
        'REGISTER_SUCCESS_SWIFT': 'Gebruiker succesvol geregistreerd, er is een e-mail verzonden naar uw gebruiker voor activering',
        'REGISTER_ERROR': 'Fout, de gebruiker kon zich niet registreren, probeer het opnieuw',
        'PRODUCT_REGISTEROK': 'Product correct geregistreerd.',
        'PRODUCT_REGISTERPREVIOUS': 'Product correct geregistreerd.',
        'PRODUCT_REGISTERFAIL': 'Fout bij registreren van product, probeer het opnieuw',
        'CERTIFICAR_EXISTENTE': 'Het gecertificeerde product bestaat al',
        'CERTIFICAR_NO_TERMINADO': 'Om het volgende product toe te voegen moet u afsluiten met het jaarcertificaat',
        'CERTIFICAR_NO_EXISTENTE': 'Om het Pulsecheck-product toe te voegen, moet u het certificaat voor dat jaar verwerven',
        'PULSOS-COMPLETOS':'Momenteel heb je de toegestane pulsen',
        'MSJ_SELECTYEAR': 'Selecteer een jaar',
        'MSJ_SELECTYEARRESULTS': 'Het is noodzakelijk om een ​​producttype te hebben',
        'MSJ_34': 'Het is noodzakelijk om een ​​producttype Certify te selecteren',
        'MSJ_35': 'Het is noodzakelijk om een ​​producttype Maat te selecteren',
        'MSJ_36': 'Het is noodzakelijk om een ​​producttype Forall te selecteren',
        'MSJ_SELECTPRODUCT': 'Selecteer een product',
        'MSJ_SELECTTEMPLETE': 'Selecteer een sjabloon',
        'MSJ_SELECTEMAILTEMPLETE': 'Selecteer een e-mailsjabloon',
        'SIN_USUARIO': 'U moet een gebruiker voor dit bedrijf registreren om dit product te kunnen toevoegen',
        //'SIN_SURVEYTOKEN': 'You need to enter the survey token to associate to this product in order to assign it',
        'MISMOANIOCERTIFICAR': 'Het product kan niet worden toegevoegd, je hebt al een Certify-product van hetzelfde jaar, selecteer een ander jaar en probeer het opnieuw',
        'SIN_SURVEYTOKEN': 'Het jaartal van dit product heeft nog geen overzicht',
        'SIN_CERTIFICAR_ASOCIA': 'U moet nog steeds een gecertificeerd product associëren',
        'SIN_TABLEAUVER': 'U moet de resultatenversie invoeren om aan dit product te koppelen om het toe te wijzen',
        'SINRANKING': 'U moet het rangschikkingsjaar voor dit product selecteren voordat u doorgaat',
        'SINTIPORANK': 'U moet het type rangschikking voor dit product selecteren voordat u doorgaat',
        'SINIDOPORTUNITY': 'U moet de opportunity-ID voor dit product invoeren voordat u doorgaat',
        'SINNAMEOPORTUNITY': 'U moet de opportunity-naam voor dit product invoeren voordat u verdergaat',
        'SINIDTYPERESULT': 'U dient het resultaattype voor dit product in te voeren alvorens verder te gaan',
        'SINPROYECTMANAGER': 'U moet de naam van de projectmanager voor dit product invoeren voordat u doorgaat',
        'SINCORREOPM': 'U moet het e-mailadres van de projectmanager voor dit product invoeren voordat u doorgaat',
        'EMAILNOVALIDO': 'Het ingevoerde e-mailadres van de projectmanager heeft niet het geldige formaat, controleer het en voer het opnieuw correct in',
        'GUARDANDOPRODUCTO': 'Het geselecteerde product wordt toegevoegd aan het bedrijf, even geduld aub',
        'TOKENMODAL_1': 'Dit is de enquêtetoken van het nieuw toegevoegde product',
        'TOKENMODAL_2': 'Wat wil je hierna doen?',
        'TOKEN_SI': 'Kopieer de token',
        'TOKEN_NO': 'Doorgaan met',
        'TOKEN_COPIADO': 'Enquêtetoken is met succes naar het klembord gekopieerd',
        'ERROR1':'U heeft dit jaar al een geregistreerd product',
        'TITUHEAD': 'Gebruikersprofiel',
        'TITUCREARHEAD': 'Gebruiker aanmaken',
        'TITUBUSCARHEAD': 'Zoek gebruiker',
        'TITUBUSCAREMPRESA': 'Zoek bedrijf',
        'TITUUSERGPTWHEAD': 'Admin-gebruikers',
        'INFO': 'Profiel voor een gebruiker',
        'USUARIO': 'E-mail',
        'USE_NAM': 'Gebruikersnaam',
        'USUARIOREQUIRED': 'Email is verplicht',
        'USUARIONAMEREQUIRED': 'Gebruikersnaam is vereist',
        'CONTRAREQUIRED': 'The password is required',
        'LEVELREQUIRED': 'Select a level',
        'CONTRA': 'Password',
        'COMPANY': 'Company',
        'NIVEL': 'Authorization Level',
        'NIVELES': catalogos.niveles,
        'GUARDA': 'Save',
        'TH-NOMEMPRE':'Bedrijfsnaam',
        'TH-USUARIO':'Gebruiker',
        'TH-TUSUARIO':'Gebruikerstype',
        'TH-ACCIONES':'Acties',
        'TH-LOGIN':'Log in',
        'TH-INSTITUTO':'Instituut',
        'ACC-DELET':'Verwijder gebruiker',
        'ACC-EDIT':'bewerk gebruiker',
        'UPDATE-USER':'Correct bijgewerkt',
        'EXIST-USER':'Existing User',
        'ALERT-EDIT':'Weet u zeker dat u de gebruiker wilt wijzigen?',
        'USUARIO-T':'Usuarios',
        'CONFIRM_ELIMINAR_USU':'Weet u zeker dat u de gebruiker wilt verwijderen?',
        'INGR_ELIMINAR_USU':'<span>Voer de rood gemarkeerde gebruiker in het tekstveld in  ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'De ingevoerde gebruiker komt niet overeen',
        'OK_ELIMINAR_USU':'Gebruiker is correct verwijderd',
        'PASSWORDSAFE': 'Het wachtwoord moet minimaal 8 tekens lang zijn: minimaal 1 cijfer, minimaal 1 kleine letter, minimaal 1 HOOFDLETTERS en minimaal 1 niet-alfanumeriek teken',
        'PRODUCT_EXIST':'Het product met de geselecteerde datum bestaat al',
        'WAR_ADD_NA_US': 'Voer de gebruikersnaam in',
        'WAR_ADD_TOT_US': 'Voer het totaal aantal medewerkers in',
        'WAR_ADD_EMA_US': 'Voer het e-mailadres van de gebruiker in',
        'WAR_ADD_PASS_US': 'Voer het gebruikerswachtwoord in',
        'WAR_INCO_EMA_US': 'Het ingevoerde e-mailadres is onjuist',
        'WAR_INCO_PASS_US':'Het wachtwoord is niet in het toegestane formaat',
        'MOD_SAV_US':'Gebruiker opslaan',
        'MENSAJES':{
          'CARGABD': 'Upload BD',
          'STATUS': 'STATUS',
          'CORRECTO': 'Gebruiker succesvol geregistreerd ',
          'ERROR': 'Er is een fout opgetreden bij het maken van het gebruikersprofiel'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO': 'Onderzoek raadplegen',
      'HEADER': 'Selecteer het instituut',
      'INSTITUTOS': 'Instituten',
      'FILTRO': 'Filter',
      'FILTRO_EMPRESA':'Filter bedrijf:',
      'FILTRO_TI_EMPR_TOKEN':'Filter token survey / company type:',
      'SELECCIONFILTRO': 'Zoek de benodigde informatie',
      'BOTON_DESCARGA_EXCEL': 'Download informatie in Excel-formaat',

      'CARGANDO': 'Informatie laden ...',
      'NOMBRE_DE_EMPRESA': 'Naam van het bedrijf',
      'TIPO_DE_EMPRESA':'Type bedrijf',
      'FECHA_C': 'Datum van creatie',
      'SECTOR': 'Sector',
      'SUBSECTOR': 'Subsector',
      'TIPO_ENC': 'Type enquête',
      'PLANTILLA': 'Sjabloon',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'TOKEN': 'Survey token',
      'ID_ENC': 'Enquête-ID',
      'ANIO': 'Jaar',
      'CORREOS_EN': 'E-mail verzonden',
      'FECHA_A': 'Datum van applicatie',
      'FECHA_CR': 'Sluitingsdatum',

      'MODAL_SUCCES': 'Bestand correct gedownload',
      'MODAL_WARNING': 'Geen instituut geselecteerd',
      'VIZUENCU':'Geef enquêtes weer',
      'SELE_AN_ENCU':'Seleccione un año',
    },
    'CONSULTAR_RT':{
      'TITULO':'Technische vereisten raadplegen',
      'HEADER': 'Selecteer het instituut',
      'INSTITUTOS': 'Instituten',
      'FILTRO': 'Filter',
      'SELECCIONFILTRO':'Zoek het gewenste bedrijf',
      'CARGANDO':'Informatie laden',
      'NOMBRE_DE_EMPRESA':'Naam van het bedrijf',
      'FECHA_DE_EMPRESA':'Datum oprichting',
      'PRODUCTO': 'Producttype',
      'TOKEN': 'Enquêtetoken',
      'ESTATUS': 'Status',
      '0':'Niet gestart',
      '1':'In bewerking',
      '2': 'Voltooid',
      'ACCIONES':'Acties',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS': 'Artikelen per pagina',
      'DE':'van',
      'SIGUIENTE':'Volgende',
      'ULTIMA':'Laatste pagina',
      'PRIMERA': 'Eerste bladzijde',
      'ANTERIOR': 'Vorige',

    },
    'PAQUETES':{
      'NOMBRES':{
        '1': 'ZILVEREN pakket',
        '2': 'GOUD pakket',
        '3': 'PLATINUM-pakket',
      },
      'TOOLTIP':{
        'CONFIG': 'Klik om te configureren',
      },
      'MENSAJES': {
        'ADDOK': 'Het pakket is met succes toegevoegd aan het bedrijf. Nu kunt u de producten van het geselecteerde pakket configureren',
        'NOTOK': 'Het pakket kon niet worden toegevoegd, er is al een pakket toegewezen aan het opgegeven jaar, probeer opnieuw een andere optie te kiezenn',
        'USURE_PROD': 'Bevestigt u dat u dit product configureert met de gekozen kenmerken?',
        'PROD_ACTIVADO': 'Dit product is al geactiveerd',
        'ONLYONE': 'In deze categorie kunt u maar één type product kiezen. Wilt u met deze keuze het proces voortzetten?',
        'NOYEAR': 'U heeft het toepassingsjaar voor het pakket niet geselecteerd',
        'NOPAQ': 'U heeft het pakket dat u wilt toewijzen niet geselecteerd',
      },
      'PREVIO':{
        'INFO': 'U heeft geen actueel productpakket actief',
        'BOTONES':{
          'ADD': 'Voeg een pakket toe',
          'SEE': 'Raadpleeg een eerder pakket',
          'CANCELAR': 'Annuleren',
          'ADDPACK': 'Pakket toevoegen',
          'SI': 'Ja',
          'NO': 'Nee',
        },
        'STEPS': {
          '1': 'Selecteer het pakket dat u aan het bedrijf wilt toewijzen',
          '2': 'Selecteer het toepassingsjaar voor het pakket',
        }
      },
      'INFOPAQ':{
        'TITULO': 'Huidig ​​pakket:',
        'APLICA': 'Toepassingsjaar:',
        'AVANCE': 'Huidige voortgang van pakketconfiguratie',
        'STATUS':{
          'TITULO': 'Toestand:',
          'OK_1': 'Volledige configuratie',
          'NOTOK_1': 'Onvolledige configuratie',
          'OK_2': 'Al geactiveerd',
          'NOTOK_2': 'Niet geactiveerd',
          'ADICIONAL': 'Aanvullende producten',
          'ADINFO': 'Opmerking: hun toevoeging is optioneel',
        },
        'BOTONES':{
          'ADD': 'Voeg product toe',
          'CANCELAR': 'annuleren',
          'SI': 'Ja',
          'NO': 'Nee',
          'BACK': 'Ga terug',
          'ADDONE': 'Voeg een product toe',
          'DETAIL': 'See details',
        },
        'CERTIFICAR':{
          'TITULO':{
            '1': 'U heeft dit product niet geactiveerd',
            '2': 'U heeft dit product al geactiveerd',
            '3': 'Dit is een categorie, u kunt de volgende producten activeren:',
            '4': 'Dit product kan tijdens de levensduur van het pakket meerdere keren worden toegewezen',
          },
          'INSTRUC': 'Configureer dit product hieronder',
          'TIPO': 'Selecteer het type product',
          'INFO':{
            'TITULO': 'Product information',
            'SECCIONES': 'Secties',
            'TIPO': 'Type',
            'TEMP': 'Geselecteerde sjabloon',
            'STATUS':{
              'TITULO': 'Huidige status',
              '1': 'Nog niet klaar',
              '2': 'Afgewerkt',
            },
            'TABLA':{
              '1': 'Product',
              '2': 'Options',
            }
          }
        }
      }
    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Automated Audit',
      'TABLA':{
        'TH-NOM-EMPRESA':'Company Name',
        'TH-NO-COLAB':'No. Collaborators',
        'TH-CONTESTADOS':'Answered',
        'TH-FALTANTES':'Missing',
        'TH-PROGRESO':'Progress',
        'TH-ACCIONES':'Actions',
        'MSJ-DETALLES':'See details',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Tijdresponsmedewerkers',
      'RES-CONT-TAB':'Controle reacties',
      'RES-COMENT-TAB':'Reacties reacties',
      'TIEM-RES-TITULO':'Controleer de reactietijd van de medewerkers',
      'RES-CONT-TITULO':'Percentage respons op controlevragen',
      'RES-COMENT-TITULO':'Percentage lege, herhaalde of herhaalde karaktercommentaar',
      'RES-AGREGAR':'Adding a sample',
      'RES-SELECCIONAR':'Select sample',
      'RES-TEXTO1':'Er is nog geen sample gemaakt',
      'RES-TEXTO2':'Selecteer een voorbeeld om de gegevens te bekijken',
      'INGRE-NOM': 'Voer de naam van het monster in',
      'SELEC-REG': 'Selecteer de regels van de steekproef',
      'REGLAS':{
        '1': 'Bijdragers die binnen 10 minuten hebben geantwoord',
        '2': 'Medewerkers die al hun items met een waarde van 5 beantwoordden',
        '3': 'Medewerkers die JA hebben geantwoord op de controlevraag',
        '4': 'Medewerkers die een willekeurige vraag verkeerd hebben beantwoord',
        '5': 'Medewerkers die meer dan 10 antwoorden hebben gewijzigd',
      },

      'TABLA':{
        'TITULO':'Gegevens van de medewerkers in de steekproef',
        'NOMBRE':'Naam',
        'TELEFONO':'Telefoon',
        'CELULAR':'mobiele telefoon',
        'CORREO':'E-mailadres',
        'COMENTARIO':'Commentary',
      },
      'MODALES':{
        'GENERANDO':'Monster genereren, even geduld ... ',
        'GUARDANDO':'Reactie opslaan, even geduld ...',
        'TITULO':'Saved comment',
        'CERRAR':'Dichtbij',
        'TITULO_INFORMACION':'Nadat u de opmerking heeft toegevoegd, mag het veld niet leeg blijven, de laatste gegevens die erin zijn opgeslagen, worden overgenomen',
        'SUCCE-MUES':'De sample is correct gemaakt',
        'WARNI-SINU':'Geen gebruikers meer om te registreren',
        'WARNI-CONDI': 'Vergeet niet een naam in te voeren en minstens één regel te selecteren',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'Verklaringen',
      'CONTROL':'Controle',
      'DEMOGRAFICOS':'Demografie',
      'ABIERTAS':'Open',
      'CA':'4ALLE',
      'CODIGOPROYECTO':'Project code: ',
      'ANIOAPLICACION':'Year of implementation: ',
      'MENSAJE':'It is not possible to download the survey, because it has not yet been created',
      'ACEPTAR':'Accept',
      'TEXTODESCARGA':'Survey of ',
      'DESCARGARENCUESTA':'Download survey',
      'INFORMACIONYAVISO':'Survey Information and Privacy Notice',
      'SECCIONES':'Sections',
      'TIPOENC1':'Minder 50',
      'TIPOENC2':'Meer 50',
      'MODAL':{
        'TITLE':'Talenlijst',
        'SUBTITLE':'Kies een taal',
        'PLACEHOLDER':'Selecteer',
        'BTNCLOSE':'Dichtbij',
        'BTNSELECT':'Aanvaarden',
        'MAS50':'Meer 50',
        'MENOS50':'Minder 50',
        'TIPOENCUESTA':'Selecteer een enquêtetype',
      }
    },
    'UPDATE_COLABORATORS':{
      'UPDATE':'Werk de medewerkersdatabase bij'
    },
    'INFORT': {
      'TITULO': 'Technische Anforderungen schreiten voran',
      'SINLANGS': 'U moet de talen in dit product selecteren om de lijst met stappen te zien',
      'PASOS': {
        'PASO_1': 'Schrittliste',
        'PASO_2': 'Fragebogen',
        'PASO_3': 'Aufzeichnung'
      },
      'LISTAPASOS': {
        'autentication': 'Umfrageauthentifizierung',
        'testAccess': 'Test anzeigen',
        'testEmail': 'Nachweis des E-Mail-Empfangs',
        'validationQ': 'Validierungsfragebogen',
        'requirements': 'Datenschutzerklärung',
      },
      'STATUS': {
        'PEND': 'steht aus',
        'DONE': 'Schritt abgeschlossen',
      },
      'RESP': 'Antwort gesendet',
      'NORESP': 'Unbeantwortet'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Specifieke infrastructuur:',
      'INSTRUC_1':'Wilt u specifieke infrastructuur toevoegen?',
      'LAB_SUBDOMINIO':'SubDomain',
      'WARN_CARACT':'Het veld staat de letter ñ, hoofdletters en speciale tekens niet toe',
      'BTN_CONTI':'Doorgaan',
      'SI':'Ja',
      'NO':'No',
      'MODA_IMPORT_SUBDOM':'Om verder te gaan moet u het subdomein invoeren',
    }
  }
};
